(() => {
  'use strict';
  const dialog = document.getElementById('vdr-faq-chat');
  const anchor = [...document.querySelectorAll('a[class]')].find(a => [...a.classList].some(c => c.startsWith('ai-whatsapp-button-')));
  if (!dialog || !anchor || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  const input = dialog.querySelector('textarea');
  const endpoint = 'https://drqxcqdeqwyrgovneufw.supabase.co/functions/v1/faq-chat';
  const tokenKey = 'vdr-faq-session-v1';
  const log = dialog.querySelector('[role="log"]');
  const status = dialog.querySelector('[role="status"]');
  const typing = document.createElement('div');
  typing.className = 'vdr-faq-typing';
  typing.dataset.faqTyping = '';
  typing.setAttribute('role', 'status');
  typing.setAttribute('aria-label', 'Admin sedang menyiapkan jawaban');
  typing.hidden = true;
  for (let i = 0; i < 3; i++) {
    const dot = document.createElement('span'); dot.setAttribute('aria-hidden', 'true'); dot.textContent = '•'; typing.append(dot);
  }
  log.append(typing);
  const form = dialog.querySelector('form');
  const submit = form.querySelector('[type="submit"]');
  const cancel = form.querySelector('[data-faq-cancel]');
  const retry = document.createElement('button');
  retry.type = 'button'; retry.dataset.faqRetry = ''; retry.hidden = true;
  retry.textContent = 'Coba lagi'; status.after(retry);
  let failedQuestion = '';
  retry.addEventListener('click', () => { if (failedQuestion) send(failedQuestion, true); });
  let active = null;
  let abortedByUser = false;
  cancel.addEventListener('click', () => { abortedByUser = true; active?.abort(); });
  let token = '';
  let busy = false;
  let lastQuestion = '';
  let requestStage = 'status';
  const errorCopy = {
    network_limit: 'Batas sesi dari jaringan ini tercapai. Tunggu atau hubungi WhatsApp admin.',
    session_limit: 'Layanan sedang membatasi sesi baru. Coba nanti atau hubungi WhatsApp admin.',
    reply_limit: 'Batas pertanyaan sesi ini tercapai. Lanjutkan ke WhatsApp admin.',
    budget_limit: 'Chat mencapai batas kapasitas layanan. Hubungi WhatsApp admin.',
    reply_unavailable: 'Balasan dari penyedia jawaban belum tersedia. Coba lagi atau hubungi WhatsApp admin.',
    invalid_session: 'Sesi chat tidak berlaku. Coba lagi untuk membuka sesi baru, atau hubungi WhatsApp admin.',
    busy: 'Permintaan sebelumnya masih diproses. Tunggu sebelum mencoba lagi.',
    network_unavailable: 'Layanan belum bisa memvalidasi koneksi. Hubungi WhatsApp admin.',
    message_too_large: 'Pesan terlalu panjang. Tulis pesan yang lebih singkat.',
    invalid_body: 'Format pesan belum diterima. Coba tulis ulang atau hubungi WhatsApp admin.',
    invalid_request: 'Permintaan belum diterima. Coba lagi atau hubungi WhatsApp admin.',
    month_boundary: 'Layanan sedang memperbarui periode. Coba beberapa saat lagi.',
    unavailable: 'Layanan chat belum tersedia. Coba nanti atau hubungi WhatsApp admin.',
    limited: 'Layanan sedang membatasi permintaan. Coba nanti atau hubungi WhatsApp admin.'
  };
  // Deliberate chat-only handoff: button, not a WhatsApp anchor intercepted by the old gate.
  // Existing contact anchors and vdr-contact-popups.js remain completely untouched.
  dialog.querySelector('[data-faq-handoff]').addEventListener('click', () => {
    const draft = input.value.trim() || lastQuestion;
    const url = new URL('https://wa.me/6282210002006');
    url.searchParams.set('text', 'Halo Admin VANDERISM, saya ingin bertanya' + (draft ? ':\n' + draft : '.'));
    window.open(url.href, '_blank', 'noopener,noreferrer');
    status.textContent = 'Draf dibuka di WhatsApp; belum terkirim. Jika tab tidak muncul, izinkan pop-up lalu klik lagi.';
  });
  try { token = sessionStorage.getItem(tokenKey) || ''; } catch (_) { /* Memory only when storage is blocked. */ }
  async function request(path, options = {}) {
    requestStage = path.slice(1);
    let response;
    try { response = await fetch(endpoint + path, {mode: 'cors', credentials: 'omit', cache: 'no-store', signal: active?.signal, ...options}); }
    catch (_) { throw {safeCode: active?.signal.aborted ? 'ABORTED' : 'NETWORK'}; }
    if (response.status === 401) {
      token = '';
      try { sessionStorage.removeItem(tokenKey); } catch (_) { /* Memory fallback. */ }
    }
    if (!response.ok) {
      let data;
      try { data = await response.json(); } catch (_) { /* Never expose raw response text. */ }
      const safeError = Object.hasOwn(errorCopy, data?.error) ? data.error : 'unavailable';
      throw {safeCode: String(response.status) + '-' + safeError.toUpperCase(), safeError};
    }
    try { return await response.json(); } catch (_) { throw {safeCode:'INVALID_RESPONSE'}; }
  }
  function addMessage(text, className, sources = []) {
    const item = document.createElement('div'); item.className = className;
    const body = document.createElement('p'); body.textContent = text; item.append(body);
    for (const source of sources) {
      try {
        const href = typeof source === 'string' ? source : source?.url;
        if (typeof href !== 'string' || !/^https:\/\/vanderism\.co\.id\/pages\/tanyajawab#faq-[0-9]+$/.test(href)) continue;
        const link = document.createElement('a'); link.href = href; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = typeof source.title === 'string' ? source.title : 'Sumber FAQ'; item.append(link);
      } catch (_) { /* Ignore invalid citations, never interpret HTML. */ }
    }
    log.append(item); log.scrollTop = log.scrollHeight;
  }
  dialog.querySelectorAll('[data-faq-question]').forEach(button => button.addEventListener('click', () => { input.value = button.dataset.faqQuestion; input.focus(); }));
  input.setAttribute('enterkeyhint', 'send');
  input.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.shiftKey || event.isComposing || event.keyCode === 229) return;
    event.preventDefault();
    if (!busy) form.requestSubmit();
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    send(input.value.trim());
  });
  async function send(message, isRetry = false) {
    if (busy || !message || message.length > 2000) return;
    lastQuestion = message;
    if (!isRetry) { addMessage(message, 'vdr-faq-question'); input.value = ''; }
    retry.hidden = true; failedQuestion = '';
    dialog.querySelector('.vdr-faq-chips').hidden = true;
    dialog.querySelector('.vdr-faq-welcome').hidden = true;
    busy = true; submit.disabled = true; cancel.hidden = false; abortedByUser = false;
    active = new AbortController();
    const timeout = window.setTimeout(() => active?.abort(), 30000);
    log.append(typing); typing.hidden = false; log.scrollTop = log.scrollHeight;
    status.textContent = '';
    try {
      const health = await request('/status');
      if (health.ready !== true) throw new Error('unavailable');
      if (!token) {
        const session = await request('/session', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: '{}'});
        if (typeof session.token !== 'string' || !session.token || !Number.isInteger(session.remaining) || session.remaining < 1) throw new Error('unavailable');
        token = session.token;
        try { sessionStorage.setItem(tokenKey, token); } catch (_) { /* Memory fallback. */ }
      }
      const result = await request('/chat', {method: 'POST', headers: {'Content-Type': 'application/json', Authorization: 'Bearer ' + token}, body: JSON.stringify({message})});
      if (typeof result.reply !== 'string' || !result.reply.trim() || !Array.isArray(result.sources) || !Number.isInteger(result.remaining) || result.remaining < 0) throw new Error('unavailable');
      addMessage(result.reply, 'vdr-faq-reply', result.sources);
      status.textContent = result.remaining === 0 ? 'Batas sesi tercapai. Kamu tetap bisa menghubungi WhatsApp admin.' : '';
    } catch (error) {
      failedQuestion = message; retry.hidden = false;
      const code = abortedByUser ? 'CANCELLED' : active.signal.aborted ? 'TIMEOUT' : error.safeCode || 'INVALID_RESPONSE';
      const explanation = abortedByUser ? 'Permintaan dibatalkan.' : active.signal.aborted ? 'Batas waktu jawaban terlewati.' : code === 'NETWORK' ? 'Koneksi ke layanan chat gagal. Coba lagi atau hubungi WhatsApp admin.' : errorCopy[error.safeError] || 'Layanan mengirim respons yang belum bisa dibaca. Hubungi WhatsApp admin.';
      status.textContent = explanation + ' [' + requestStage.toUpperCase() + '-' + code + ']' + (requestStage === 'chat' && !['invalid_session','reply_limit','budget_limit','busy'].includes(error.safeError) ? ' Proses sebelumnya mungkin sudah berjalan; coba lagi mengirim permintaan baru.' : ' Pesan tetap di sini.');
    } finally {
      window.clearTimeout(timeout);
      typing.hidden = true;
      busy = false; active = null; submit.disabled = false; cancel.hidden = true;
    }
  }
  dialog.querySelector('[data-faq-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { if (busy) { abortedByUser = true; active?.abort(); } anchor.setAttribute('aria-expanded', 'false'); anchor.focus({preventScroll: true}); });
  // Keep Tab within the dialog rather than handing focus to browser chrome.
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('a[href],button,textarea')].filter(node => !node.disabled && node.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  // A visual viewport can shrink independently of the layout viewport on mobile.
  // Keep the composer above the keyboard; CSS still owns shrinking/scrolling content.
  function fitViewport() {
    if (!dialog.open) return;
    const viewport = window.visualViewport;
    if (!viewport) return;
    const mobile = window.matchMedia('(max-width:749px)').matches;
    const gap = mobile ? 8 : 20;
    const height = Math.min(mobile ? 720 : 680, Math.max(0, viewport.height - gap * 2));
    dialog.style.top = (viewport.offsetTop + viewport.height - gap - height) + 'px';
    dialog.style.bottom = 'auto';
    dialog.style.height = height + 'px';
    dialog.style.maxHeight = Math.max(0, viewport.height - gap * 2) + 'px';
  }
  window.visualViewport?.addEventListener('resize', fitViewport);
  window.visualViewport?.addEventListener('scroll', fitViewport);
  window.addEventListener('resize', fitViewport);
  anchor.addEventListener('click', event => { event.preventDefault(); if (!dialog.open) dialog.showModal(); fitViewport(); anchor.setAttribute('aria-expanded', 'true'); input.focus({preventScroll: true}); });
  anchor.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); anchor.click(); } });
  anchor.href = '#vdr-faq-chat';
  anchor.removeAttribute('target');
  anchor.setAttribute('role', 'button');
  anchor.setAttribute('aria-label', 'Buka chat Admin VANDERISM');
  anchor.setAttribute('aria-haspopup', 'dialog');
  anchor.setAttribute('aria-controls', dialog.id);
  anchor.setAttribute('aria-expanded', 'false');
  anchor.classList.add('vdr-faq-launcher');
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS(svg.namespaceURI, 'path');
  path.setAttribute('d', 'M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 4V6a2 2 0 0 1 2-2Zm2 5h10M7 13h6');
  svg.append(path); anchor.replaceChildren(svg);
  dialog.dataset.initialized = 'true';
})();
